import { ScheduleTeam } from 'app/models/schedule.model';
import { ShiftModel } from 'app/models/shift.model';

function vehicleNameByIdFromShifts(shifts: ShiftModel[]): Map<number, string> {
    const map = new Map<number, string>();
    for (const shift of shifts || []) {
        const name = shift.vehicle?.name?.trim();
        if (shift.vehicle_id != null && name) {
            map.set(shift.vehicle_id, name);
        }
    }
    return map;
}

/** Subtítulo exibido no accordion (viatura). */
export function teamSubtitle(team: ScheduleTeam): string | null {
    const name = team.vehicle_name?.trim();
    if (name) return name;
    if (team.vehicle_id != null) return `Viatura ${team.vehicle_id}`;
    return null;
}

function applyVehicleNames(teams: ScheduleTeam[], shifts: ShiftModel[]): ScheduleTeam[] {
    const byVehicleId = vehicleNameByIdFromShifts(shifts);
    return teams.map((team) => {
        const resolved =
            team.vehicle_name?.trim() ||
            (team.vehicle_id != null ? byVehicleId.get(team.vehicle_id) ?? null : null);
        if (!resolved || resolved === team.vehicle_name) {
            return team;
        }
        return { ...team, vehicle_name: resolved };
    });
}

/**
 * Enriquece as equipes vindas da escala (já sem equipe remota — o backend
 * exclui `group_type='REMOTE'`/`type='DOCTOR'` de `GET /schedule`) com o nome
 * da viatura de `GET /shifts`.
 */
export function enrichTeamsWithRemoteShifts(
    teams: ScheduleTeam[],
    shifts: ShiftModel[],
): ScheduleTeam[] {
    return applyVehicleNames(teams || [], shifts);
}
